var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{ref:"chart",attrs:{"type":"line","height":"200","options":_vm.chartRealtimeOptions,"series":_vm.seriesRealtime}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }